import React from 'react'
import _ from 'lodash'
import { withStyles, Card, Link } from '@zn-material-ui'
import classNames from 'classnames'
import styles from '../styles/ToolCard'
import { transform } from '@utils/intl_lang'
interface ITask {
  name: string
  path: string
  key: string
  type: number
  isShow: boolean
  count: string
  countName: string
  isSeat?: boolean
}

const tasks = [
  {
    // '我的课程'
    name: transform('my_course'),
    path: '#/home/myCourse',
    key: 'course',
    type: 0,
    isShow: true,
    count: '0',
    countName: ['courseCount'],
  },
  {
    // '我的考试'
    name: transform('my_exam'),
    path: '#/home/myExam',
    key: 'exam',
    type: 30,
    isShow: true,
    count: '0',
    countName: ['examCount'],
  },
  {
    // '学习地图'
    name: transform('learn_map'),
    path: '#/home/studyMapList',
    key: 'studyMap',
    type: 56,
    isShow: true,
    count: '0',
    countName: ['studyMapCount'],
  },
  {
    // '面授班'
    name: transform('training_class'),
    path: '#/home/myTrainingClass',
    key: 'myTrainingClass',
    type: 51,
    isShow: true,
    count: '0',
    countName: ['classCount'],
  },
  {
    // '我的问卷'
    name: transform('my_questionnaire'),
    path: '#/home/myQuestionnaire',
    key: 'myQuestionnaire',
    type: 57,
    isShow: true,
    count: '0',
    countName: [], // 1220版本	问卷入口不处理小红点任务提醒逻辑
  },
  {
    // '实践培训'
    name: transform('practice_train'),
    path: '#/home/practiceTrain/list',
    key: 'practiceTrain',
    type: 74,
    isShow: true,
    count: '0',
    countName: ['practicalContent'],
  },
  {
    // '作业'
    name: transform('homeWork'),
    path: '#/home/myWork',
    key: 'work',
    type: 83,
    isShow: true,
    count: '0',
    countName: ['homeWorkCount'],
  },
  {
    // '培训项目'
    name: transform('training_project'),
    path: '#/home/trainingProjectList',
    key: 'trainingProject',
    type: 87,
    isShow: true,
    count: '0',
    countName: [],
  },
  // {
  //   // 已购课程
  //   name: transform('purchased_course'),
  //   path: '#/home/myBoughtCourse',
  //   key: 'myBoughtCourse',
  //   type: 107,
  //   isShow: true,
  //   count: '0',
  //   countName: [],
  // },
  // {
  //   name: transform('study_card_paid'),
  //   path: '#/home/learnCard',
  //   key: 'learnCard',
  //   type: 119,
  //   isShow: true,
  //   count: '0',
  //   countName: [],
  // },
  {
    name: transform('live'),
    path: '#/home/livelist/1',
    key: 'liveRoom',
    type: 125,
    countName: [],
  },
  {
    // 题库
    name: transform('question_bank'),
    path: '#/home/examLibrary/',
    key: 'examLibrary',
    type: 65,
    isShow: true,
    count: '0',
    countName: [],
  },
  {
    name: transform('job_develop_path'),
    path: '#/home/jobDevelopPath',
    key: 'developDath',
    type: 145,
    isShow: true,
    count: '0',
    countName: [],
  }
]
interface IProps {
  classes?: any
  operationList: any
  courseCount: string
  examCount: string
  studyMapCount: string
  practicalContent: string,
  questionCount: string,
  newQuestionnaireCount: string
  homeWorkCount: string
}

function ToolCard(props: IProps) {
  const { classes, operationList = [] } = props
  const operationTask = tasks.map((item: any) => {
    const isShow = operationList.some(
      (operation: any) => operation.id === item.type
    )
    const count = item.countName.reduce((ttl: number, cur: string) => {
      const num = Number(props[cur]) || 0
      return ttl + num
    }, 0)
    const index = operationList.findIndex((operation: any) => operation.id === item.type)
    if (index !== -1) {
      return { ...item, name: operationList[index].name, isShow, count: String(count) }
    }
    return { ...item, isShow, count: String(count) }
  })
  const entryLen = operationTask.length
  let groups =
    entryLen > 4 && entryLen % 3 === 0
      ? operationTask
      : operationTask.concat([{ isSeat: true, isShow: true }])
  groups = _.chunk(
    groups.filter(v => v.isShow),
    entryLen > 4 ? 3 : 2
  )
  const justifyContent = entryLen > 4 ? 'space-between' : 'space-around'
  const renderQuickEntry = (item: ITask) =>
    item.isSeat ? (
      <div className={classes.seat} key="_isSeat" />
    ) : (
      <Link
        href={item.path}
        key={item.key}
        // zn-i18n-disable-next-line
        data-event-category="01Web-智门户首页"
        // zn-i18n-disable-next-line
        data-event-label="0109Web-查看学习任务项"
        data-event-mapkv={JSON.stringify({
          // zn-i18n-disable-next-line
          from: '01Web-智门户首页',
          title: item.name,
        })}
      >
        <div className={classes.iconItem}>
          <span className={classNames(classes.icon, classes[item.key])} />
          {item.count !== '0' && (
            <span className={classes.count}>{item.count}</span>
          )}
          <span className={classes.cardTitle}>{item.name}</span>
        </div>
      </Link>
    )
  return (
    <Card className={classes.card}>
      {/* 学习任务 */}
      <p className={classes.title}>{transform('learn_tasks', {}, 1)}</p>
      <div className={classes.iconBar}>
        {groups.map((row, index) => (
          <div
            key={index}
            className={classes.entryWrapper}
            style={{ justifyContent }}
          >
            {row.map(renderQuickEntry)}
          </div>
        ))}
      </div>
    </Card>
  )
}

export default withStyles(styles)(ToolCard)
